import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {iFrameAuthService} from "../../services/IFrameAuthService.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {CTA_URL} from "../PanelConstants.js";

export class AuthFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.auth;

    async start() {
        const startPath = Router.getCurrentPath();
        await iFrameAuthService.promptAuthenticationIfNeeded();
        if (startPath === CTA_URL) {
            Router.changeURL(startPath);
        } else {
            Router.changeURL(startPath);
        }
    }
}
